module.exports = __webpack_public_path__ + "img/pic.4dbbbe31.png";